import { OpenBankingProviderId } from './open-banking-provider-id';

export const environment = {
    name: 'mtf',
    production: true,
    url: 'https://services.testapp.dev.moovetshop.com/',
    openBankingProvider: 'finicity' as OpenBankingProviderId,
    translationBucketUrl: 'https://moovet-acquirer.s3.amazonaws.com/moovetpay-acquirer/translation/mc_ob_test_app/',
    translationBucketUrlFull: 'https://moovet-acquirer.s3.amazonaws.com/moovetpay-acquirer/translation/mc_ob_test_app/en-US.json',
    googleSiteKey: '6LfweS4rAAAAAHSAxa0eAfRZ9FNK-emOV_NTt0LI',
};
